export default __webpack_public_path__ + "static/media/coverBg.cf640007.png";